// extracted by mini-css-extract-plugin
export default {"dropdown":"Custom_dropdown__RaqHx","dropdownMenu":"Custom_dropdownMenu__eBwIY","desktopDropdown":"Custom_desktopDropdown__IRC8A","dropdownToggle":"Custom_dropdownToggle__P0IXF"};